var _ellipse, _ellipse2, _ellipse3, _ellipse4, _path, _path2, _path3, _path4, _path5, _ellipse5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClaim1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 282,
    viewBox: "0 0 279 282",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 176,
    cy: 199.5,
    rx: 103,
    ry: 71.5,
    fill: "#EFEFEF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.5,
    cy: 204,
    rx: 126.5,
    ry: 78,
    fill: "url(#paint0_linear_321_362)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 122.5,
    cy: 181.5,
    rx: 111.5,
    ry: 67.5,
    fill: "#F9FAFB"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.5,
    cy: 175.5,
    rx: 107.5,
    ry: 66.5,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.512 2.00554C64.3276 3.97374 63.8632 7.74613 64.0291 9.3863L76.9658 170.287L151.6 212.603C155.979 216.146 162.049 218.344 164.537 219C170.109 218.606 171.834 214.244 172 212.111V64.4961C172 57.0169 166.361 51.8668 163.541 50.2266L77.4633 1.02144C74.677 -0.553121 71.3267 0.0373394 69.9999 0.52939L67.512 2.00554Z",
    fill: "#3B33C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M155.094 62.3746L155.359 62.5256L155.645 62.6288C157.414 63.2653 162.371 66.7458 161.367 75.5745L161.344 75.7716V75.9701V212.725C161.324 212.829 161.289 212.964 161.235 213.105C161.156 213.308 161.072 213.432 161.021 213.489C161.019 213.492 161.016 213.494 161.014 213.496C161.003 213.498 160.988 213.499 160.97 213.5L72.9813 164.455C71.9498 163.785 70.3338 162.376 69.1193 160.461C67.9028 158.542 67.2039 156.314 67.6226 153.86L67.6725 153.568V153.272V150.825V12.6477C68.0945 12.7806 68.684 13.0241 69.4641 13.4585L155.094 62.3746ZM66.9233 12.5002C66.9207 12.5005 66.9193 12.5006 66.9193 12.5006L66.9233 12.5002Z",
    fill: "#F3F2FF",
    stroke: "#6C63FF",
    strokeWidth: 7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86 9.99995L87 13.4999V28.5L143.5 64.5L150 59.5L151 42.5C151 36.5 146.667 32.6667 144.5 31.5L133.5 25.5C133.5 18.7 127.5 11.6667 124.5 9C117.7 2.2 110 6.8333 107 9.99995L101 5.99995C97.8 3.99995 95.3334 4.49995 94.5 4.99995C86.5 7.79995 85.5 9.49995 86 9.99995Z",
    fill: "#BB0478"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M85 29.9998L143.5 64.4998V43.9998C143.5 41.1998 141.5 39.4998 140.5 38.9998L126 29.4998C126 21.0998 117.167 15.1665 115 13.4998C105.4 5.09984 102.333 11.6665 102 15.9998L90 9.4998C86 7.0998 85 10.5 85 11.5V29.9998Z",
    fill: "#EF069A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85 30L138.5 61.5V46C138.5 43.2 136.5 41.5 135.5 41L122 32.5C122 24.1 117.167 20.1667 115 18.5C105.4 10.1 102.333 16.6667 102 21L90 14.5C86 12.1 85 13.5 85 14.5V30Z",
    fill: "#FF3BB8"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 110.127,
    cy: 29.1516,
    rx: 5.85369,
    ry: 7.15451,
    transform: "rotate(-11.1542 110.127 29.1516)",
    fill: "#BB0478"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8944 44.0652L94.8944 51.0652C95.572 51.404 96 52.0966 96 52.8541V69.9262C96 71.4474 94.3691 72.4117 93.0362 71.6786L79.0362 63.9786C78.3971 63.6271 78 62.9556 78 62.2262V45.8541C78 44.3673 79.5646 43.4003 80.8944 44.0652Z",
    fill: "#6C63FF",
    stroke: "#6C63FF",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83 55L87.5 62.5L98.5 51.5",
    stroke: "#F3F2FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 58.5L120 68",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M126 71L149 84",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M104 68L150 94",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M104 77L134 93",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8944 84.0652L94.8944 91.0652C95.572 91.404 96 92.0966 96 92.8541V109.926C96 111.447 94.3691 112.412 93.0362 111.679L79.0362 103.979C78.3971 103.627 78 102.956 78 102.226V85.8541C78 84.3673 79.5646 83.4003 80.8944 84.0652Z",
    fill: "#6C63FF",
    stroke: "#6C63FF",
    strokeWidth: 2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83 95L87.5 102.5L98.5 91.5",
    stroke: "#F9FAFB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 98.5L120 108",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M126 111L149 124",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M104 108L150 134",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M104 117L134 133",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8944 124.065L94.8944 131.065C95.572 131.404 96 132.097 96 132.854V149.926C96 151.447 94.3691 152.412 93.0362 151.679L79.0362 143.979C78.3971 143.627 78 142.956 78 142.226V125.854C78 124.367 79.5646 123.4 80.8944 124.065Z",
    fill: "#6C63FF",
    stroke: "#6C63FF",
    strokeWidth: 2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M83 135L87.5 142.5L98.5 131.5",
    stroke: "#F9FAFB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M103.5 138.5L120 148",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M126 151L149 164",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M104 148L150 174",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M104 157L134 173",
    stroke: "#6C63FF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_321_362",
    x1: 253,
    y1: 197.5,
    x2: 11.5,
    y2: 197.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaim1);
export default __webpack_public_path__ + "static/media/Claim1.23d2fc17b0e25e42a663f5f555aec37c.svg";
export { ForwardRef as ReactComponent };